export const validateFileSize = (file, maxSize, questionName, t) => {
  if (file && file.size > maxSize) {
    const maxSizeMB = maxSize / 1048576;
    throw new Error(
      `${t('Size of the')} ${questionName} ${t('file is too big. Max')} ${maxSizeMB}MB`
    );
  }
};

export const processAnswersWithFiles = async (array, options = {}) => {
  const { validateFiles = false, maxFileSize = 10485760, t } = options;
  
  const alreadyClearedQuestions = {};
  const answersArray = [];
  const files = {};

  if (validateFiles) {
    array.forEach((ans) => {
      if (ans.file) {
        validateFileSize(ans.file, maxFileSize, ans.questionName, t);
      }
    });
  }

  const filteredAnswers = array.filter(
    (answer) => answer.answer || answer.availableAnswerId || answer.file
  );

  await Promise.all(
    filteredAnswers.map(
      (answer) =>
        new Promise(async (resolve, reject) => {
          try {
            const { clearAll, key, prePostCallback, file, group, ...answerParams } = answer;

            if (prePostCallback && key !== 'file') {
              answerParams[key] = await prePostCallback();
            }

            if (key === 'file') {
              if (prePostCallback) {
                const result = await prePostCallback();
                if (result) files[answer.fieldname] = result;
              } else {
                files[answer.fieldname] = answer.file;
              }
            }

            answersArray.push({
              ...answerParams,
              clearAll: clearAll && !alreadyClearedQuestions[answer.questionId]
            });

            if (clearAll) alreadyClearedQuestions[answer.questionId] = true;

            resolve();
          } catch (e) {
            reject(e);
          }
        })
    )
  );

  return { answersArray, files };
};

